import ConsultingRequestsPage from "../../pages/admin/ConsultingRequestsPage";

export default function AdminConsultingPage() {
  return <ConsultingRequestsPage />;
}